// To translate
export const _en = {
    menuItems: {
        return: {
            label: "Back"
        },
        generalData: {
            label: "Globals info"
        },
        learningContent: {
            label: "Contenu pédagogique"
        },
        planning: {
            label: "Séances",
            dirtyTooltip: "Le contenu du stage à changé, il est nécéssaire de regénérer les séances"
        },
        groups: {
            label: "Groupes"
        }
    },
    generalDisplay: {
        addBtn: {
            label: "Training course",
            tooltip: "Add a course"
        },
        addDialog: {
            title: "Training course generation",
            confirmBtn: {
                label: "Select"
            },
            discardBtn: {
                label: "Cancel"
            }
        },
        refTrainingProductPrefixId: {
            AFCA: {
                label: "Prefix"
            },
            ATO: {
                label: "Code"
            }
        }
    },
    generalData: {
        createBtn: {
            label: "Perform training course creation"
        },
        productInfoAccordion: {
            title: "Training product globals information"
        },
        generatedForm: {
            suffixDuration: {
                label: "Jour"
            },
            organizationSelect: {
                placeHolder: "Select an organization"
            }
        }
    },
    teachingData: {
        smartSelect: {
            typeResourceSelect: {
                placeHolder: "No type selected"
            },
            emptyValue: {
                label: "Empty value"
            }
        },
        button: {
            choice: {
                label: "Choice"
            }
        },
        title: {
            typeSkill: {
                label: "Skill type"
            }
        },
        modal: {
            addSkill: {
                title: "Add a skill"
            }
        },
        neededResource: {
            modal: {
                warning: {
                    title: "Remove or change reference resource ",
                    body: "The resource is already configured with a reference. Are you sure you want to change the reference type or delete it?",
                    butonOk: "Confirm"
                }
            }
        }

    },
    planning: {
        buttons: {
            generation: {
                label: "Generate course sessions"
            },
            manualTrigger: {
                label: "Run resource association"
            },
            listView: {
                label: "Vue liste",
                tooltip: "Programme pédagoqique en vue liste"
            },
            planningView: {
                label: "Vue planning",
                tooltip: "Programme pédagoqique en vue planning"
            },
            resourceAssignation: {
                label: "Resource association",
                tooltip: "Perform auto resource association"
            },
            massResourceAssignation: {
                tooltip: "Open the resource assignment optimization modal"
            }
        },
        checkbox: {
            checkBoxToShowResources: {
                label: "Toggle training course ressource"
            },
            checkBoxToShowNeededResources: {
                label: "Resources needs"
            },
            checkBoxToShowExternalTasks: {
                label: "Toggle externals sessions display"
            }
        },
        modal: {
            overrite: {
                title: "Warning: confirming will overwrite the previous schedule!"
            },
            overriteAll: {
                title: "Warning: confirming will overwrite the groups and the previous schedule!"
            },
            overriteGroup: {
                title: "Warning, confirming will overwrite the groups!"
            },
            resourceAssignation: {
                title: {
                    add: "Resource association",
                    update: "Update resource association"
                },
                prerequisiteSwitch: {
                    label: "Toggle resource need check"
                },
                recomandedAssignation: {
                    label: "Add the recommended resources"
                },
                smartSelect: {
                    resourceType: {
                        placeHolder: "Select a resource type"
                    },
                    skills: {
                        placeHolder: "Select skills"
                    },
                    resources: {
                        placeHolder: "Select resource"
                    }
                },
                unassignationModal: {
                    title: "Unassign resource"
                }
            },
            error: {
                title: "Error"
            }
        },
        smartSelect: {
            smartSelectTypeRessource: {
                placeholder: "Select a resource type"
            },
            smartSelectSkilRessource: {
                placeholder: "Select skills"
            },
            smartSelectRessource: {
                placeholder: "Select resource"
            }
        },
        listView: {
            paramsTab: {
                title: "Settings"
            },
            resourcesTab: {
                title: "Assigned resources"
            }
        },
        AssocietedRessourceTab: {
            headerTabHuman: {
                title: "Assigned human resource(s)"
            },
            headerTabMaterial: {
                title: "Assigned material resource(s)"
            },
            columnSmartTable: {
                action: {
                    title: "Action(s)"
                },
                role: {
                    title: "Role",
                    propertyName: "resourceRole"
                },
                skill: {
                    title: "Skills",
                    titleMaterial: "Caractéristiques",
                    propertyName: "resourceSkills"
                }
            }
        },

        errors: {
            modal: { title: "Transgression of training course constraints" },
            overlap: "Invalid change: Multiple sessions overlap.",
            wrongDay: "Invalid change: The activity date does not correspond to its specified module/day.",
            wrongHours: "Invalid change: The activity times do not match the training course parameters.",
            ressourceCategoryMismatch: "The new resource is not in the same category.",
            wrongDayStart: "Warning, this action changes the training course start date ({{startDate}}).",
            wrongDayFinish: "Warning, this action changes the effective training course date ({{finishDate}}).",
            wrongHourStart: "Warning, this action moves the session before the start time defined for this course ({{startHour}}).",
            wrongHourFinish: "Warning, this action moves the session past the end time defined for this course ({{finishHour}}).",
            sessionOnMultipleDay: "Please note that this action moves the session to two separate days.",
            wrongNewDayStart: "Please note that this action moves the session to a different day than the one originally scheduled.",
            startDateIsAboutToChange: "Warning, this action changes the training course start date ({{startDate}}).",
            finishDateIsAboutToChange: "Warning, this action changes the training course end date ({{finishDate}}).",
            confirmationQuestion: "Do you want to reschedule the session?"
        },
        report: {
            state: {
                basic: {
                    label: "Simple",
                    tooltip: "Planning without resource optimization or consideration of prerequisites"
                },
                optional: {
                    label: "Flexible",
                    tooltip: "Planning without optional prerequisites"
                },
                strict: {
                    label: "Stricte",
                    tooltip: "Planning that takes prerequisites into account"
                }
            }
        }
    },
    groups: {
        customGroups: {
            label: "G{{nbTrainee}}",
            quadDigitLibelle: "",
            prom: "Promotion",
            desc: "Custom group of {{nbTrainee}} trainee(s)",
            type: "Custom"
        },
        columns: {
            label: "Libellé",
            labelTooltip: "Nom du groupe",
            quadDigitLibelle: "Groupe QUAD",
            quadDigitLibelleTooltip: "Index de rattachement QUAD du groupe",
            desc: "Description",
            descTooltip: "Description et typologie du groupe",
            type: "Type",
            typeTooltip: "Code typologie du groupe",
            nbTrainee: "Nombre de stagiaire(s)",
            nbTraineeTooltip: "Nombre de stagiaire(s) inscrit(s) sur le groupe",
            trainees: "Stagiaires",
            traineesTooltip: "Liste des stagiaires inscrits sur le groupe",
            actions: "Action(s)",
            actionsTooltip: "Liste des actions permises sur le groupe"
        },
        buttons: {
            delete: "Delete",
            traineeRegister: "Register trainees",
            traineeRegisterTooltip: "Add some trainees"
        },
        trainees: {

            modal: {
                add: "Add trainees",
                addModalTitle: "Trainee Inscription",
                addModalTraineeToAddCount: "Trainee count to add",
                addModalTraineeHourGlassServiceDisplay: "Creation of trainee groups with their sessions.",
                edit: "Editing by a group of trainees",
                editTrainees: "Trainee edition",
                delete: "Trainee deletion",
                deleteHourGlassServiceDisplay: "Removal of interns and rescheduling of sessions according to the new composition",
                deleteGroupDisplay: "- The group's composition will no longer conform to its definition",
                editTraineeWarning: "In the event of a change in the group typology (SC/NSC), new sessions may be generated."
            },
            tab: {
                columns: {
                    refTraineePositionId: "Type",
                    actions: "Action(s)",
                    defaultEmptyValue: "Not specified"
                }
            },
            notification: {
                GroupUpdate: {
                    createdSessionPrefix: "New(s) session(s) created"
                }
            }
        }
    }
};

export const _fr = {
    menuItems: {
        return: {
            label: "Retour"
        },
        generalData: {
            label: "Informations générales"
        },
        learningContent: {
            label: "Contenu pédagogique"
        },
        planning: {
            label: "Séances",
            dirtyTooltip: "Le contenu du stage à changé, il est nécéssaire de regénérer les séances"
        },
        groups: {
            label: "Groupes"
        }
    },
    generalDisplay: {
        addBtn: {
            label: "Stage",
            tooltip: "Créer un stage"
        },
        addDialog: {
            title: "Génération d'un stage",
            confirmBtn: {
                label: "Sélectionner"
            },
            discardBtn: {
                label: "Annuler"
            }
        },
        refTrainingProductPrefixId: {
            AFCA: {
                label: "Préfixe"
            },
            ATO: {
                label: "Code"
            }
        }
    },
    generalData: {
        createBtn: {
            label: "Créer le stage"
        },
        productInfoAccordion: {
            title: "Informations du modèle de stage"
        },
        generatedForm: {
            suffixDuration: {
                label: "Jour"
            },
            organizationSelect: {
                placeHolder: "Sélectionner une compagnie"
            }
        }
    },
    teachingData: {
        smartSelect: {
            typeResourceSelect: {
                placeHolder: "Pas de type défini"
            },
            emptyValue: {
                label: "Pas de valeur"
            }
        },
        button: {
            choice: {
                label: "Choix"
            }
        },
        title: {
            typeSkill: {
                label: "Type de compétence"
            }
        },
        modal: {
            addSkill: {
                title: "Ajouter Compétence"
            }
        },
        neededResource: {
            modal: {
                warning: {
                    title: "Suppresion ou changement de référence",
                    body: "La ressource est déjà paramétrée avec une référence. Êtes-vous sûr de changer le type de référence ou la supprimer ?",
                    butonOk: "Confirmer"
                }
            }
        }

    },
    planning: {
        buttons: {
            generation: {
                label: "Génerer les séances du stage"
            },
            manualTrigger: {
                label: "Relancer l'association des ressources"
            },
            listView: {
                label: "Vue liste",
                tooltip: "Programme pédagoqique en vue liste"
            },
            planningView: {
                label: "Vue planning",
                tooltip: "Programme pédagoqique en vue planning"
            },
            resourceAssignation: {
                label: "Associer des ressources",
                tooltip: "Associer des ressources à une activité automatiquement ou non"
            },
            massResourceAssignation: {
                tooltip: "Ouvrir la modale d'optimisation des assignations des ressources"
            }
        },
        checkbox: {
            checkBoxToShowResources: {
                label: "Afficher les ressources du stage"
            },
            checkBoxToShowNeededResources: {
                label: "Besoins en ressources"
            },
            checkBoxToShowExternalTasks: {
                label: "Activités externes au stage"
            }
        },
        modal: {
            overrite: {
                title: "Attention, en validant vous allez écraser la planification précédente !"
            },
            overriteAll: {
                title: "Attention, en validant vous allez écraser les groupes et la planification précédente !"
            },
            overriteGroup: {
                title: "Attention, en validant vous allez écraser les groupes !"
            },
            resourceAssignation: {
                title: {
                    add: "Association des ressources",
                    update: "Édition de la ressource"
                },
                prerequisiteSwitch: {
                    label: "Activer la prise en compte des besoins en ressources"
                },
                recomandedAssignation: {
                    label: "Ajouter les ressources recommandées"
                },
                smartSelect: {
                    resourceType: {
                        placeHolder: "Sélectionnez un type de ressources"
                    },
                    skills: {
                        placeHolder: "Sélectionnez des compétences"
                    },
                    resources: {
                        placeHolder: "Sélectionnez une ressource"
                    }
                },
                unassignationModal: {
                    title: "Retirer la ressource de la séance"
                }
            },
            error: {
                title: "Erreur"
            }
        },
        smartSelect: {
            smartSelectTypeRessource: {
                placeholder: "Sélectionner un type de resource"
            },
            smartSelectSkilRessource: {
                placeholder: "Sélectionner une compétence"
            },
            smartSelectRessource: {
                placeholder: "Sélectionner une resource"
            }
        },
        listView: {
            paramsTab: {
                title: "Paramètres"
            },
            resourcesTab: {
                title: "Ressources assignées"
            }
        },
        AssocietedRessourceTab: {
            headerTabHuman: {
                title: "Ressource(s) humaine(s) mobilisée(s)"
            },
            headerTabMaterial: {
                title: "Ressource(s) matérielle(s) mobilisée(s)"
            },
            columnSmartTable: {
                action: {
                    title: "Action(s)"
                },
                role: {
                    title: "Rôle",
                    propertyName: "resourceRole"
                },
                skill: {
                    title: "Compétences",
                    titleMaterial: "Caractéristiques",
                    propertyName: "resourceSkills"
                }
            }
        },

        errors: {
            modal: { title: "Transgression des contraintes du stage" },
            overlap: "Changement invalide: Plusieurs activitées se superposent.",
            wrongDay: "Changement invalide: La date de l'activité ne correspond pas à son module/jour renseigné.",
            wrongHours: "Changement invalide: Les horaires de l'activité ne correspondent pas aux paramètres du stage.",
            ressourceCategoryMismatch: "La nouvelle ressource n'a pas la même categorie.",

            wrongDayStart: "Attention, cette action modifie la date de début de stage ({{startDate}}).",
            wrongDayFinish: "Attention, cette action modifie la date effective de stage ({{finishDate}}).",
            wrongHourStart: "Attention, cette action déplace la séance avant l'heure de début définie pour ce stage ({{startHour}}).",
            wrongHourFinish: "Attention, cette action déplace la séance après l'heure de fin définie pour ce stage ({{finishHour}}).",
            sessionOnMultipleDay: "Attention, cette action déplace la séance sur deux journées distinctes.",
            wrongNewDayStart: "Attention, cette action déplace la séance sur une autre journée que celle initialement prévue.",
            startDateIsAboutToChange: "Attention, cette action modifie la date de début de stage ({{startDate}}).",
            finishDateIsAboutToChange: "Attention, cette action modifie la date de fin de stage ({{finishDate}}).",
            confirmationQuestion: "Voulez-vous déplacer la séance ?"
        },
        report: {
            state: {
                basic: {
                    label: "Simple",
                    tooltip: "Planification sans optimisation de ressources ni prise en compte des prérequis"
                },
                optional: {
                    label: "Flexible",
                    tooltip: "Planification sans les prérequis optionnels"
                },
                strict: {
                    label: "Stricte",
                    tooltip: "Planification avec la prise en compte des prérequis"
                }
            }
        }
    },
    groups: {
        customGroups: {
            label: "G{{nbTrainee}}",
            quadDigitLibelle: "",
            prom: "Promotion",
            desc: "Groupe personnalisé de {{nbTrainee}} stagiaire(s)",
            type: "Personnalisé"
        },
        columns: {
            label: "Libellé",
            labelTooltip: "Nom du groupe",
            quadDigitLibelle: "Groupe QUAD",
            quadDigitLibelleTooltip: "Index de rattachement QUAD du groupe",
            desc: "Description",
            descTooltip: "Description et typologie du groupe",
            type: "Type",
            typeTooltip: "Code typologique du groupe",
            nbTrainee: "Nombre de stagiaire(s)",
            nbTraineeTooltip: "Nombre de stagiaire(s) inscrit(s) sur le groupe",
            trainees: "Stagiaires",
            traineesTooltip: "Liste des stagiaires inscrits sur le groupe",
            actions: "Action(s)",
            actionsTooltip: "Liste des actions permises sur le groupe"
        },
        buttons: {
            delete: "Supprimer",
            traineeRegister: "Inscrire des stagiaires",
            traineeRegisterTooltip: "Ajouter des stagiaires"
        },
        trainees: {
            modal: {
                add: "Ajout de stagiaires",
                addModalTitle: "Inscriptions stagiaires",
                addModalTraineeToAddCount: "Nombre de stagiaire à ajouter",
                addModalTraineeHourGlassServiceDisplay: "Création des groupes de stagiaires avec leurs séances.",
                edit: "Édition d'un groupe de stagiaires",
                editTrainees: "Édition des stagiaires",
                delete: "",
                deleteHourGlassServiceDisplay: "Suppresion de stagiaires et replanification des séances selon la nouvelle composition",
                deleteGroupDisplay: " - La composition du groupe ne respectera plus sa définition",
                editTraineeWarning: "En cas de modification de la typologie du groupe (SC/NSC) de nouvelles séances pourront être générées."
            },
            tab: {
                columns: {
                    refTraineePositionId: "Type",
                    actions: "Action(s)",
                    defaultEmptyValue: "Non renseigné"
                }
            },
            notification: {
                GroupUpdate: {
                    createdSessionPrefix: "Nouvelle séance créée"
                }
            }
        }
    }
};